/**
 * BusinessEnvironmentFactor CRUD
 */

import type { BusinessEnvironmentFactor } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateBusinessEnvironmentFactorInput {
  name: string;
  description?: string;
  category?: string;
  label?: string;
  tags?: string[];
  notes?: string;
}

export interface UpdateBusinessEnvironmentFactorInput {
  name?: string;
  description?: string;
  category?: string;
  label?: string;
  tags?: string[];
  notes?: string;
}

const client = createEntityCrudClient<
  BusinessEnvironmentFactor,
  CreateBusinessEnvironmentFactorInput,
  UpdateBusinessEnvironmentFactorInput
>('/business-environment-factors');

/**
 * Create a new business environment factor
 */
export async function createBusinessEnvironmentFactor(
  input: CreateBusinessEnvironmentFactorInput
): Promise<BusinessEnvironmentFactor> {
  return client.create(input);
}

/**
 * Update an existing business environment factor
 */
export async function updateBusinessEnvironmentFactor(
  businessEnvironmentFactorId: string,
  input: UpdateBusinessEnvironmentFactorInput
): Promise<BusinessEnvironmentFactor> {
  return client.update(businessEnvironmentFactorId, input);
}

/**
 * Delete a business environment factor
 */
export async function deleteBusinessEnvironmentFactor(
  businessEnvironmentFactorId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(businessEnvironmentFactorId, hardDelete);
}
